import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
  useRouteContext,
} from '@tanstack/react-router';
import { type MenuProps } from 'antd';
import { Shield, User } from 'lucide-react';
import { useMemo } from 'react';

import { SettingsLayout } from '../../../../ui/components/layout';

const settingsMenuLink = (to: string, text: string) => (
  <Link to={to} className="settings-layout-menu-item-link">
    {text}
  </Link>
);

function SuperadminSettingsLayoutComponent() {
  const location = useLocation();

  const { account } = useRouteContext({ from: '/_authenticated' });

  const menuItems: MenuProps['items'] = useMemo(() => {
    return [
      {
        type: 'group',
        label: (
          <span
            style={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {`${account.firstName} ${account.lastName}`}
          </span>
        ),
        children: [
          {
            key: '/superadmin/settings/profile',
            label: settingsMenuLink('/superadmin/settings/profile', 'Profile'),
            icon: <User size="1em" />,
          },
          {
            key: '/superadmin/settings/security',
            label: settingsMenuLink('/superadmin/settings/security', 'Security'),
            icon: <Shield size="1em" />,
          },
        ],
      },
    ];
  }, [account]);

  const menuProps: Pick<MenuProps, 'items' | 'selectedKeys'> = useMemo(
    () => ({
      items: menuItems,
      selectedKeys: [location.pathname],
    }),
    [menuItems, location.pathname],
  );

  return (
    <SettingsLayout menuProps={menuProps}>
      <Outlet />
    </SettingsLayout>
  );
}

export const Route = createFileRoute('/_authenticated/superadmin/settings')({
  component: SuperadminSettingsLayoutComponent,
});
